export default __webpack_public_path__ + "static/media/beach.85e603ca.mp4";